module.exports = __webpack_public_path__ + "src/assets/images/login/Nitro_logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/Nitro_logo.png
// module id = 2313
// module chunks = 4